import axios from 'axios';

import { fdApiUse } from '../apiUtils';
import {
  Campaign,
  CollectionLocationArea,
  CollectionRestaurantDetail,
  CollectionRestaurantSummary,
  DeliveryRestaurantDetail,
  DeliveryRestaurantSummary,
  GetCampaignProgressQueryParams,
  GetCollectionLocationAreasQueryParams,
  GetCollectionSummariesQueryParams,
  GetDeliveryDetailQueryParams,
  GetDeliverySummariesQueryParams,
} from './restaurant.types';

// #region get requests
export const getCollectionSummaries = (
  queryParams: GetCollectionSummariesQueryParams,
): Promise<CollectionRestaurantSummary[]> =>
  fdApiUse(
    axios.get('/Restaurant/PickupPhysicalRestaurantSummariesFromCoordinates', {
      params: queryParams,
    }),
  ).then((data: CollectionRestaurantSummary[]) => data);

export const getDeliverySummaries = (
  queryParams: GetDeliverySummariesQueryParams,
): Promise<DeliveryRestaurantSummary[]> =>
  fdApiUse(
    axios.get('/Restaurant/DeliveryRestaurantSummaries', {
      params: queryParams,
    }),
  ).then((data: DeliveryRestaurantSummary[]) => data);

export const getCollectionDetail = (
  prId: number,
): Promise<CollectionRestaurantDetail> =>
  fdApiUse(axios.get(`/Restaurant/PickupRestaurantDetails/${prId}`)).then(
    (data: CollectionRestaurantDetail) => data,
  );

export const getDeliveryDetail = (
  vrId: number,
  queryParams: GetDeliveryDetailQueryParams,
): Promise<DeliveryRestaurantDetail> =>
  fdApiUse(
    axios.get(`/Restaurant/DeliveryRestaurantDetails/${vrId}`, {
      params: queryParams,
    }),
  ).then((data: DeliveryRestaurantDetail) => data);

export const getCampaignProgress = (
  queryParams: GetCampaignProgressQueryParams,
): Promise<Campaign[]> =>
  fdApiUse(
    axios.get('/marketing/GetUserStatusOnLoyaltyCampaign', {
      params: queryParams,
    }),
  ).then((data: Campaign[]) => data);

export const getCollectionLocationAreas = (
  queryParams: GetCollectionLocationAreasQueryParams,
): Promise<CollectionLocationArea[]> =>
  fdApiUse(
    axios.get('/Restaurant/GetLocationAreasForStore', {
      params: queryParams,
    }),
  ).then((data: CollectionLocationArea[]) => data);
// #endregion
